<template>
  <tenant-form @submit="add" />
</template>

<script>
import { db, getUid } from '@/plugins/firebase';
import { storage, functions } from 'firebase/app';
import 'firebase/storage';
import 'firebase/functions';
import dayjs from 'dayjs';
import TenantForm from './TenantForm.vue';

export default {
  name: 'AddTenant',
  components: { TenantForm },
  filters: {
    formatDate: value => value && dayjs(value).format('MM/DD/YYYY'),
  },
  methods: {
    async add(image, tenant) {
      const { data: uid } = await functions().httpsCallable('createTenantAccount')({
        email: tenant.email,
        admin: getUid(),
      });
      await Promise.all([
        db
          .collection('users')
          .doc(uid)
          .update({ ...tenant, admin: getUid() }),
        storage()
          .ref(`tenants/${uid}`)
          .put(image),
      ]);
      this.$router.push('tenants');
    },
  },
};
</script>

<style></style>
